import { Text, TextInput } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { useFormContext } from "react-hook-form";
import { useIsOnline } from "src/hooks";

import {
  StyledRemoveActionIcon,
  StyledYachtSetUpItem,
} from "../YachtSetUp.styled";

interface Props {
  id: string;
  remove: () => void;
}

const CabinItem = ({ id, remove }: Props) => {
  const { register } = useFormContext();
  const isOnline = useIsOnline();
  return (
    <StyledYachtSetUpItem>
      <Text size={"sm"}>Cabin Name:</Text>
      <TextInput
        style={{ flex: 1 }}
        {...register(id, { disabled: !isOnline })}
      />
      {isOnline && (
        <StyledRemoveActionIcon onClick={remove} variant="outline" size={"sm"}>
          <IconX />
        </StyledRemoveActionIcon>
      )}
    </StyledYachtSetUpItem>
  );
};

export default CabinItem;
